import React from "react";
import styled from "styled-components";

export default styled.section`
    height: 100vh;    
    background: white;
    width: 338px;
    position: absolute;
    left: -338px;
    top: 0;
    bottom: 0;
    z-index: 4;
    transition: 100ms all linear;
    box-sizing: border-box;
    border-right: 1px solid #979797; 
    
    ${(props) => (props.open ? {
    'left': '81px',
    'transition': '100ms all linear'
} : '')}
`;